import React, { memo } from 'react'
import propTypes from 'prop-types'
import { DropdownButton, Form, Button } from 'react-bootstrap'
import './styles.scss'

const SelectImageType = ({ imageTypes, setImageTypes }) => {
  const safeImageTypes = imageTypes || []

  const toggleItemsInImageTypeList = (target) => {
    let list
    if (target && target.checked) {
      list = safeImageTypes.concat(target.value)
    } else {
      list = safeImageTypes.filter((type) => type !== target.value)
    }
    setImageTypes(list)
  }

  const toggleAll = () => {
    if (safeImageTypes.length > 0) {
      setImageTypes([])
    } else {
      setImageTypes([
        'arasaac',
        'kuvako',
        'mulberry',
        'drawing',
        'sclera',
        'toisto',
        'photo',
        'sign',
      ])
    }
  }

  return (
    <>
      <DropdownButton
        id="dropdown-item-button"
        title={`Kuvatyypit (${safeImageTypes.length})`}
        role="menuitemcheckbox"
      >
        <Form tabIndex={0}>
          <Form.Control
            as="fieldset"
            multiple
            onChange={(e) => toggleItemsInImageTypeList(e.target)}
          >
            <Button className="all-types-button" onClick={toggleAll}>
              {safeImageTypes.length > 0 ? 'Poista kaikki' : 'Valitse kaikki'}
            </Button>
            <Form.Label as="arasaac-checkbox">
              <Form.Check
                checked={safeImageTypes.indexOf('arasaac') > -1}
                onChange={(e) => toggleItemsInImageTypeList(e.target)}
                type="checkbox"
                value="arasaac"
                label="ARASAAC-piirroskuvat"
                id="arasaac-checkbox"
                tabIndex={0}
              />
            </Form.Label>
            <Form.Label as="kuvako-checkbox">
              <Form.Check
                checked={safeImageTypes.indexOf('kuvako') > -1}
                onChange={(e) => toggleItemsInImageTypeList(e.target)}
                type="checkbox"
                value="kuvako"
                label="KUVAKO-kuvat"
                id="kuvako-checkbox"
              />
            </Form.Label>
            <Form.Label as="mulberry-checkbox">
              <Form.Check
                checked={safeImageTypes.indexOf('mulberry') > -1}
                onChange={(e) => toggleItemsInImageTypeList(e.target)}
                type="checkbox"
                value="mulberry"
                label="Mulberry-kuvat"
                id="mulberry-checkbox"
              />
            </Form.Label>
            <Form.Label as="drawing-checkbox">
              <Form.Check
                checked={safeImageTypes.indexOf('drawing') > -1}
                onChange={(e) => toggleItemsInImageTypeList(e.target)}
                type="checkbox"
                value="drawing"
                label="Piirroskuvat"
                id="drawing-checkbox"
              />
            </Form.Label>
            <Form.Label as="sclera-checkbox">
              <Form.Check
                checked={safeImageTypes.indexOf('sclera') > -1}
                onChange={(e) => toggleItemsInImageTypeList(e.target)}
                type="checkbox"
                value="sclera"
                label="Sclera-piktogrammit"
                id="sclera-checkbox"
              />
            </Form.Label>
            <Form.Label as="toisto-checkbox">
              <Form.Check
                checked={safeImageTypes.indexOf('toisto') > -1}
                onChange={(e) => toggleItemsInImageTypeList(e.target)}
                type="checkbox"
                value="toisto"
                label="Toisto-kuvat"
                id="toisto-checkbox"
              />
            </Form.Label>
            <Form.Label as="photo-checkbox">
              <Form.Check
                checked={safeImageTypes.indexOf('photo') > -1}
                onChange={(e) => toggleItemsInImageTypeList(e.target)}
                type="checkbox"
                value="photo"
                label="Valokuvat"
                id="photo-checkbox"
              />
            </Form.Label>
            <Form.Label as="sign-checkbox">
              <Form.Check
                checked={safeImageTypes.indexOf('sign') > -1}
                onChange={(e) => toggleItemsInImageTypeList(e.target)}
                type="checkbox"
                value="sign"
                label="Viittomakuvat"
                id="sign-checkbox"
              />
            </Form.Label>
          </Form.Control>
        </Form>
      </DropdownButton>
    </>
  )
}

SelectImageType.propTypes = {
  imageTypes: propTypes.instanceOf(Array),
  setImageTypes: propTypes.func.isRequired,
}

SelectImageType.defaultProps = {
  imageTypes: [],
}

export default memo(SelectImageType)
